const module = { name: 'shared/merchCarousel.app', exports: {} }; const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_debugLog as debugLog } from 'require-core';



import { default as modal } from 'swug-fdRequire-call:Fandango/modal';



import { Fandango_carousel as fdCarousel } from 'require-global';



import { default as offerModal } from 'swug-fdRequire-call:shared/offerModal';



import { default as Fandango_triggerEvent_triggerAnalyticsEvent_isMobile } from 'swug-fdRequire-call:Fandango/triggerEvent';

const { triggerAnalyticsEvent, isMobile } = Fandango_triggerEvent_triggerAnalyticsEvent_isMobile;


const Selectors = {
    MERCH_CAROUSEL: '.merch-carousel',
    MERCH_CAROUSEL_MODAL_TRIGGER: '.js-merch-carousel-trigger',
    MERCH_CAROUSEL_ITEMS: '.merch-carousel .splide__slide',
    MERCH_CAROUSEL_SINGLE_ITEM: '.merch-carousel--single-item',
    MERCH_CAROUSEL_CONTAINER: '.movie-detail-header__merch-carousel',
    MERCH_CAROUSEL_ARROW_RIGHT: '.merch-carousel__arrow-right',
}
function triggerMerchAnalytics(eventName, tilePosition, carouselName) {
    triggerAnalyticsEvent(eventName, {
        pageName: 'movie | overview',
        pageType: 'movie overview page',
        carouselName,
        carouselTilePosition: tilePosition,
        screenWidth: window.innerWidth,
    });
}
function handleModalTrigger(e) {
    e.preventDefault();
    const trigger = e.currentTarget;
    const modalHeadline = trigger.dataset.modalHeadline || '';
    const carouselName = modalHeadline ? `${modalHeadline} - merchCarousel` : 'merchCarousel';
    const tile = trigger.closest('.splide__slide');
    const tiles = document.querySelectorAll(`${Selectors.MERCH_CAROUSEL} .splide__slide`);
    const index = Array.from(tiles).indexOf(tile);
    const tilePosition = index >= 0 ? index + 1 : '';
    triggerMerchAnalytics('carouselTileClick', tilePosition, carouselName);
}
function adjustCarouselWidth() {
    const carouselItems = document.querySelectorAll(Selectors.MERCH_CAROUSEL_ITEMS);
    const carousel = document.querySelector(Selectors.MERCH_CAROUSEL);
    if (carouselItems.length <= 1) {
        carousel.classList.add(Selectors.MERCH_CAROUSEL_SINGLE_ITEM);
    }
    else {
        carousel.classList.remove(Selectors.MERCH_CAROUSEL_SINGLE_ITEM);
    }
}
function hideEmptyCarousel() {
    const carouselItems = document.querySelectorAll(Selectors.MERCH_CAROUSEL_ITEMS);
    const carouselContainer = document.querySelector(Selectors.MERCH_CAROUSEL_CONTAINER);
    if (carouselContainer && carouselItems.length === 0) {
        carouselContainer.style.display = 'none';
    }
}
function run() {
    checkDependencies(module.name, debugLog);
    fdCarousel.init('merchCarousel', {
        autoWidth: true,
        fixedWidth: '220px',
        padding: isMobile ? { left: '16px', right: '16px' } : { left: 0, right: 0 }
    });
    const merchCarousel = fdCarousel.getInstance('merchCarousel');
    if (merchCarousel) {
        merchCarousel.on('move', () => {
            triggerMerchAnalytics('carouselSwipe', '', 'merchCarousel');
        });
        adjustCarouselWidth();
        hideEmptyCarousel();
        modal.merch(Selectors.MERCH_CAROUSEL_MODAL_TRIGGER);
        const modalTriggers = document.querySelectorAll(Selectors.MERCH_CAROUSEL_MODAL_TRIGGER);
        modalTriggers.forEach((trigger) => {
            trigger.addEventListener('click', handleModalTrigger);
        });
        offerModal.init();
    }
}
run();
export default module.exports;